module.exports = __webpack_public_path__ + "img/work-7.f642e3f5.png";